const COMMON_URL = `${process.env.REACT_APP_COMMON_SERVICE_ORIGIN_URL}/account-setup`
const PARTY_RESOURCE_URL = `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr`

const AccessLevelCompanyApiUrls = {
  GET_BY_PARTY_SERVICE: `${PARTY_RESOURCE_URL}/party/get`,
  GET: `${COMMON_URL}/access-level-company/hdr/get`,
  POST: `${COMMON_URL}/access-level-company/hdr/create`,
  PUT: `${COMMON_URL}/access-level-company/hdr/update`,
  DELETE: `${COMMON_URL}/access-level-company/hdr/delete`,
  EXPORT: `${COMMON_URL}/access-level-company/hdr/download`
}

export default AccessLevelCompanyApiUrls
